import telegramRequest from "./requests/telegram-request";
import telegramExitRequest from "./requests/telegram-exit-request";
import updateUserRequest from "./requests/update-user-request";
import getUsersWithPermRequest from "./requests/get-users-with-perm-request";
import registerRequest from "./requests/register-request";
import deleteRequest from "./requests/delete-request";

const adduserRepository = {
    telegram: telegramRequest,
    telegramExit: telegramExitRequest,
    updateUser: updateUserRequest,
    getUsersWithPerm: getUsersWithPermRequest,
    register: registerRequest,
    delete: deleteRequest,
};

export default adduserRepository;